"use strict";
/*
 * Created on 01 21 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var immutable_1 = require("immutable");

var DomainObject_1 = require("../DomainObject");
/**
 * <p>
 * Generic representation of the concept of events that in some way affect one or more entities. For example, it may
 * be a change of a product category, a change of product activity, and so on. Model is generic, but these specific events can be
 * modelled as concrete implementations of {@link AdtFlag flag concept} (within specific module). In application, you may want to
 * filter only changes related to particular entities (groups). Since events can be handled in different parts of the system, there
 * is need to store information about so called tasks, that have already processed the event.
 * </p>
 *
 * @author JMe
 */


var EntityEvent =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(EntityEvent, _DomainObject_1$Domai);

  /**
   * @param id internal id
   * @param groupToEntities mapping of classification of affected entities (e.g. only products) to their ids.
   * @param issued date of issuing of event
   * @param event concrete event (modelled as abstract flag instead of one giant enum)
   * @param processedByTasks stores information about task ids that have already reacted to an event
   */
  function EntityEvent(id, groupToEntities, // re-discuss type { entityGroup: string; entityId: string }
  issued, event, processedByTasks) {
    var _this;

    _classCallCheck(this, EntityEvent);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(EntityEvent).call(this));
    _this.id = id;
    _this.groupToEntities = groupToEntities;
    _this.issued = issued;
    _this.event = event;
    _this.processedByTasks = processedByTasks;
    return _this;
  }
  /**
   * @param entityRecord the entity with group identification to be added
   * @returns modified entity event
   */


  _createClass(EntityEvent, [{
    key: "addEntity",
    value: function addEntity(entityRecord) {
      var groupEntities;

      if (this.groupToEntities.has(entityRecord.entityGroup)) {
        groupEntities = this.groupToEntities.get(entityRecord.entityGroup);
      } else {
        groupEntities = immutable_1.Set();
      }

      return this.copy('groupToEntities', this.groupToEntities.set(entityRecord.entityGroup, groupEntities.add(entityRecord.entityId)));
    }
    /**
     * Gets all affected entities by an event.
     *
     * @returns list of this.entityIds
     */

  }, {
    key: "getEntityIds",
    value: function getEntityIds() {
      return immutable_1.Set(this.groupToEntities.values()).flatMap(function (s) {
        return s;
      });
    }
    /**
     * Gets all classifications of affected entities (e.g. only products) by an event.
     * @returns list of this.entityGroups
     */

  }, {
    key: "getEntityGroups",
    value: function getEntityGroups() {
      return immutable_1.Set(this.groupToEntities.keys());
    }
  }]);

  return EntityEvent;
}(DomainObject_1.DomainObject);

exports.EntityEvent = EntityEvent;